import api from "@/plugins/axios";
import { useUserStore } from "@/store/userStore";
import router from "@/router";

export function fetchUser() {
  const userStore = useUserStore();
  api
    .get("auth/me")
    .then((response) => {
      userStore.setUser(response.data.data);
    })
    .catch((error) => {
      console.log(error);
      if (error.response?.status == 401) {
        localStorage.removeItem("user_token");
        userStore.setUser({});
        router.push({ name: "login" });
      }
    });
}
